<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header.bg-info(style="color: white")
				span.fa.fa-gear.mr-2
				span Configura el traspaso
				span.close(@click="cerrar") &times;
			.card-body
				.form-group
					label
						b Selecciona el agente de destino
					input-query(
						inputClass="form-control"
						placeholder="Nombre"
						:realtime="true"
						url="gestion-clientes/php/api/buscaAgente.php"
						@selected="seleccionaAgente"
						v-if="!datos.AgenteID"
					)
					.input-group(v-else)
						input.form-control(disabled="true" :value="AgenteNombre")
						.input-group-append
							button.btn.btn-danger(@click="datos.AgenteID = null")
								span.fa.fa-trash
			.card-body.bg-light(v-if="datos.AgenteID")
				div
					b ¿Migrar contratos, facturación y cobros?
				.input-group.mt-2
					.input-group-prepend
						.input-group-text
							input(type="checkbox", v-model="datos.contratos")
					.input-group-append.input-group-prepend
						.input-group-text Desde
					vc-date-picker.form-control(
						:disabled="!datos.contratos"
						v-model="datos.FechaInicioContratos"
						:input-props=`{
							placeholder: 'Desde la fecha',
							class: 'inputFecha',
							readonly: true,
							masks: {
								input: "['MMM, YYYY']"
							}
						}`,
						:masks=`{
							input: ['MMM YYYY']
						}`
					)
			.card-body.bg-light(v-if="datos.AgenteID")
				div
					b ¿Migrar anunciantes relacionados?
				.input-group.mt-2
					.input-group-prepend
						.input-group-text
							input(type="checkbox", v-model="datos.anunciantes")
					.input-group-append.input-group-prepend
						.input-group-text Sí
			.card-body.bg-light(v-if="datos.AgenteID")
				div
					b ¿Migrar producciones relacionadas?
				.input-group.mt-2
					.input-group-prepend
						.input-group-text
							input(type="checkbox", v-model="datos.producciones")
					.input-group-append.input-group-prepend
						.input-group-text Desde
					vc-date-picker.form-control(
						:disabled="!datos.contratos"
						v-model="datos.FechaInicioProducciones"
						:input-props=`{
							placeholder: 'Desde la fecha',
							class: 'inputFecha',
							readonly: true,
							masks: {
								input: "['MMM, YYYY']"
							}
						}`,
						:masks=`{
							input: ['MMM YYYY']
						}`
					)
			.card-footer
				button.btn.btn-primary(@click="asignar") Asignar
</template>

<script>
import axios from 'axios'
export default {
	props: ['clientes'],
	data () {
		return {
			datos: {
				AgenteID: null,
				FechaInicioContratos: null,
				FechaInicioProducciones: null,
				contratos: true,
				anunciantes: true,
				producciones: true
			},
			AgenteNombre: null
		}
	},
	methods: {
		seleccionaAgente (ev) {
			this.datos.AgenteID = ev.datos.ID
			this.AgenteNombre = ev.datos.nombre
		},
		asignar () {
			if (!this.datos.AgenteID) {
				this.$error('Error', 'No has seleccionado el agente')
				return
			}

			if (this.datos.contratos && !this.datos.FechaInicioContratos) {
				this.$error('Error', 'No has la fecha de inicio de los contratos a migrar')
				return
			}

			if (this.datos.producciones && !this.datos.FechaInicioProducciones) {
				this.$error('Error', 'No has la fecha de inicio de las producciones a migrar')
				return
			}

			const form = JSON.parse(JSON.stringify(this.datos))
			form.FechaInicioContratos = this.datos.FechaInicioContratos ? this.$moment(this.FechaInicioContratos).format('DD-MM-YYYY') : null
			form.FechaInicioProducciones = this.datos.FechaInicioProducciones ? this.$moment(this.FechaInicioProducciones).format('DD-MM-YYYY') : null
			form.clientes = this.clientes
			this.$store.commit('alertas/confirm', {
				titulo: 'Traspasar clientes',
				mensaje: `¿Quieres continuar con el traspaso de clientes?`,
				callback: acepta => {
					if (acepta) {
						axios.post('gestion-clientes/php/api/cartera/asignar.php', form)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Traspaso realizado con éxito'
								})
								this.$emit('traspasado')
								this.cerrar()
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>


<style>
.inputFecha {
	border: 0;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/traspaso-cartera/seleccion-agente.component.vue